import * as React from 'react'
import Typography from '@mui/material/Typography'
import {useNavigate, useParams} from 'react-router-dom'
import {selectClassificationTree} from '../../search/rtkSearchApi'
import {useSelector} from 'react-redux'
import {ROUTES} from '../../constants/routing'
import {useDatxPathGenerator} from '../../util/routing'
import { TreeItem, TreeItemProps, useTreeItemUtils } from '@mui/x-tree-view'
import './ClassificationTreeDrawer.scss'

interface CustomLabelProps {
    children: React.ReactNode;
    itemId: string;
    isParent: boolean;
  }
  
const CustomLabel =({children , itemId, isParent}: CustomLabelProps) => {

    const navigate = useNavigate()
    const generatePath = useDatxPathGenerator()
    const {classificationId} = useParams()

    const handleOnClick = () => {
        navigate(
            {pathname: generatePath(ROUTES.searchByClassificationNodeDescendants.path, {classificationId : itemId}),
            search: '?page=1'
        })
    }

    return (
        <Typography
            data-testid={itemId + '-view-items'}
            component="div"
            id={isParent ? 'classification-node-label-parent' : 'classification-node-label-children'}
            className={itemId === classificationId ? 'clicked' : 'default'}
            onClick={handleOnClick}
        >
            {children}
        </Typography>
    )
}

const CustomContainer = ({itemId, children, isParent}: CustomLabelProps) =>{

    const classificationTree = useSelector(selectClassificationTree)
    const {
        status
    } = useTreeItemUtils({itemId : itemId})

    const doesClassificationNodeHaveChildren = (nodeId: any, node: any) => {
        return node.children?.some((subNode: any) => {
                if (subNode.id === nodeId && subNode.children?.length > 0) {
                    return true
                } else if (subNode.id !== nodeId) {
                    return doesClassificationNodeHaveChildren(nodeId, subNode)
                }
                return false
            }
        )
    }
    return (
        <div id="custom-tree-view-component-children">
            <div id={isParent && status.expanded ? 'expand-classification-node-parent'
                     :
                     (doesClassificationNodeHaveChildren(itemId, classificationTree) ? 'expand-classification-node-children' : 'expand-classification-node-children-no-children')
            }>
                {children}
            </div>
        </div>
    )
}

const CustomIconContainer = ({itemId, children, isParent}: CustomLabelProps) => {
    const {
        interactions,
    } = useTreeItemUtils({itemId : itemId})

return (
    <div 
        id={isParent ? 'classification-node-icon-parent' : 'classification-node-icon-children'}
        data-testid={itemId + '-view-children'}
        onClick={(event) => interactions.handleExpansion(event)}
    >
        {children}
    </div>
)
}
export const CustomTreeItem = React.forwardRef(function CustomTreeItem(
    props : TreeItemProps,
    ref: React.Ref<HTMLLIElement>
) {
    const isClassificationNodeAParent = (nodeId: any) => {
        return classificationTree.children?.some(
            (node) => node.id === nodeId)
    }
    const classificationTree = useSelector(selectClassificationTree)

    return (
        <TreeItem
            {...props}
            ref={ref}
            slots={
                {
                    label: CustomLabel,
                    content: CustomContainer,
                    iconContainer: CustomIconContainer
                }
            }
            slotProps={{
                label: {
                    itemId: props.itemId
                } as CustomLabelProps,
                content: {
                    itemId: props.itemId,
                    isParent: isClassificationNodeAParent(props.itemId)
                } as CustomLabelProps,
                iconContainer: {
                    itemId: props.itemId
                } as CustomLabelProps,
                root : {className : 'custom-tree-view-component-container-children-main' }
            }}
        />
    )
})